import { create } from 'zustand';
import { getConnectedUserAccounts } from '../api/getConnectedUserAccounts';
import { AuthAccount, ConnectedUserAccount, OperationCount, ConnectedOrganization } from '../types';
import sortBy from 'lodash/sortBy';
import { getOperationCount } from '../api/getOperationCount';
import { getConnectedOrganizations } from '../api/getConnectedOrganizations';

type IntegrationsStore = {
  connectedUserAccounts: ConnectedUserAccount[];
  connectedOrganizations: ConnectedOrganization[];
  isLoadingConnectedUserAccounts: boolean;
  isLoadingConnectedOrganizations: boolean;
  loadConnectedUserAccounts: (partnerId: string, orgId: string) => Promise<void>;
  authAccounts: AuthAccount[];
  isLoadingAuthAccounts: boolean;
  setAuthAccounts: (authAccounts: AuthAccount[]) => void;
  setIsLoadingAuthAccounts: (loading: boolean) => void;
  operationsCount: OperationCount[];
  isLoadingOperationsCount: boolean;
  loadOperationsCount: (orgId: string, partner: string) => Promise<void>;
  loadConnectedOrganizations: (partnerId: string, orgId: string, userId: string) => Promise<void>;
};

const initialState = {
  isLoadingConnectedUserAccounts: false,
  isLoadingConnectedOrganizations: false,
  connectedUserAccounts: [],
  isLoadingAuthAccounts: false,
  authAccounts: [],
  operationsCount: [],
  isLoadingOperationsCount: false,
  connectedOrganizations: [],
};

export const useIntegrationsStore = create<IntegrationsStore>()((set) => ({
  ...initialState,
  loadConnectedUserAccounts: async (partnerId, orgId) => {
    set({ isLoadingConnectedUserAccounts: true });
    const response = await getConnectedUserAccounts({ partnerId, orgId });
    if (response?.data) {
      set({
        connectedUserAccounts: sortBy(response.data, 'name'),
      });
    }
    set({ isLoadingConnectedUserAccounts: false });
  },
  loadConnectedOrganizations: async (partnerId, orgId, userId) => {
    set({ isLoadingConnectedOrganizations: true });

    const response = await getConnectedOrganizations({ partnerId, orgId, userId });

    if (response?.data) {
      set({
        connectedOrganizations: sortBy(response.data, 'partner_org_name'),
      });
    }
    set({ isLoadingConnectedOrganizations: false });
  },
  loadOperationsCount: async (org_id, partner) => {
    set(() => ({
      isLoadingOperationsCount: true,
    }));
    const response = await getOperationCount({ org_id, partner });
    if (response) {
      set(() => ({
        operationsCount: response,
      }));
    }
    set(() => ({
      isLoadingOperationsCount: false,
    }));
  },
  setAuthAccounts: (authAccounts) => {
    set(() => ({
      authAccounts,
    }));
  },
  setIsLoadingAuthAccounts: (isLoadingAuthAccounts) => {
    set(() => ({
      isLoadingAuthAccounts,
    }));
  },
}));
